/**
 * API 根地址（含 /api 前缀，勿带末尾斜杠）
 * 示例：https://service.api.njhaoguanjia.cn/api
 */
export const API_BASE =
  process.env.VUE_APP_API_ORIGIN || 'https://service.api.njhaoguanjia.cn/api'

/** 站点根域名（不含 /api），用于静态资源等 */
export const API_HOST = API_BASE.replace(/\/api\/?$/, '')

export const WS_ORIGIN =
  process.env.VUE_APP_WS_ORIGIN || 'wss://service.api.njhaoguanjia.cn'

/** @deprecated 使用 API_BASE */
export const API_ORIGIN = API_BASE

export function apiOriginPath(path = '') {
  if (!path) return API_BASE
  const p = path.startsWith('/') ? path : `/${path}`
  if (p.startsWith('/api')) return `${API_HOST}${p}`
  return `${API_BASE}${p}`
}
